module.exports = __webpack_public_path__ + "img/modelo-hortifruti.b2a72060.png";